import { useI18n } from '../i18n';

/**
 * 语言切换器（分段控件）
 *
 * - compact（默认）：顶栏使用，显示「中 / EN」
 * - full：设置页使用，显示「中文 / English」
 */
export default function LangSwitch({ full = false }: { full?: boolean }) {
  const { lang, setLang, t } = useI18n();

  return (
    <div className="lang-switch" role="group" aria-label={t('lang.switch')}>
      <button
        type="button"
        className={`lang-btn${lang === 'zh' ? ' active' : ''}`}
        aria-pressed={lang === 'zh'}
        onClick={() => setLang('zh')}
      >
        {full ? t('lang.zh') : '中'}
      </button>
      <button
        type="button"
        className={`lang-btn${lang === 'en' ? ' active' : ''}`}
        aria-pressed={lang === 'en'}
        onClick={() => setLang('en')}
      >
        {full ? t('lang.en') : 'EN'}
      </button>
    </div>
  );
}
